const state = {
    menu_user_company: [],
};

export default state;